import apiClient from './client';
import type { ContactStatusValue } from './plantersService';

export interface AdminHubContactSummary {
  total: number;
  contacted: number;
  pending: number;
  overdue: number;
  needsInPerson: number;
  exempt: number;
}

export interface AdminHubOverviewPlanter {
  id: number;
  name: string;
  spouseName?: string | null;
  status?: string | null;
  stage?: string | null;
  city?: string | null;
  state?: string | null;
  assignedHub?: string | null;
  headshotImagePath?: string | null;
  /** Legacy-safe wire value; use `contactStatusDetail` or `effectiveHubContactStatus` for full semantics. */
  contactStatus: ContactStatusValue;
  contactStatusDetail?: ContactStatusValue;
  lastContact: { contactDate: string } | null;
  touchStatus?: 'contacted' | 'pending' | 'overdue';
  inPersonRequired?: boolean;
  inPersonStatus?: 'contacted' | 'pending' | 'overdue';
  lastInPersonContact?: { contactDate: string; contactType: string } | null;
  contactCadence?: {
    touchFrequencyDays: number;
    phaseLabel: string;
    inPersonRequired: boolean;
  };
  effectivePlantingStep?: string | null;
  pathKind?: string | null;
}

export interface AdminHubLeaderInfo {
  id: number;
  firstName: string;
  lastName: string;
  email?: string;
}

export interface AdminHubOverviewItem {
  id: number | null;
  name: string;
  hubLeader: AdminHubLeaderInfo | null;
  planters: AdminHubOverviewPlanter[];
  summary: AdminHubContactSummary;
}

export interface AdminHubContactOverviewResponse {
  success: boolean;
  data: AdminHubOverviewItem[];
  cadenceInfo: string;
  /** @deprecated Mobile legacy */
  frequencyDays: number;
  periodStart: string;
  periodEnd: string;
}

export const getAdminHubContactOverview = async (): Promise<AdminHubContactOverviewResponse> => {
  const response = await apiClient.get<AdminHubContactOverviewResponse>('/admin/hub-contact-overview?include=userLink');
  return response.data;
};

export function adminHubStableId(hub: AdminHubOverviewItem): string {
  if (hub.id != null) return `hub-${hub.id}`;
  if (hub.hubLeader?.id != null) return `leader-${hub.hubLeader.id}`;
  return `orphan-${hub.name}`;
}
